import React, { memo, useCallback, useContext } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { toggleSkipRow } from '@actions/batch-actions';

import BatchContext from '@components/batch/batch-upload-edit/batch-context';
import { getBatchRow } from '@selectors/batch-edit-selector';

import { FormControlLabel, Switch } from '@mui';

import './content-header.scss';

const ContentHeader = () => {
  const { batch: { rows }, fileId, rowId, rowIndex } = useContext(BatchContext);
  const dispatch = useDispatch();
  const batchRow = useSelector(state => getBatchRow(state, fileId, rowId));

  const onToggleClick = useCallback(event => {
    event.stopPropagation();
  }, []);

  const onToggleChange = useCallback(() => {
    dispatch(toggleSkipRow({ fileId, rowId }));
  }, [dispatch, fileId, rowId]);

  return (
    <div styleName="batch-upload-edit-content-header">
      <div styleName="header-title">
        {rowIndex + 1} of {rows?.length}
      </div>
      <div styleName="header-toggle-container">
        <FormControlLabel
          control={
            <Switch
              onClick={onToggleClick}
              onChange={onToggleChange}
              checked={batchRow?.skipped === true}
              color="primary"
            />
          }
          label={<span styleName="header-toggle">Skip this entity</span>}
        />
      </div>
    </div>
  );
};

export default memo(ContentHeader);

